export default "__VITE_ASSET__TneRiDZ4__"